import {
  fetchAllCertsByEnvId,
  getCertLabel,
  selectCertificatesByEnvId,
} from "@app/deploy";
import { useQuery, useSelector } from "@app/react";
import { Select, type SelectOption } from "./select";

export const CertSelector = ({
  envId,
  onSelect,
  selectedId,
  className = "",
}: {
  envId: string;
  onSelect: (opt: SelectOption) => void;
  selectedId: string;
  className?: string;
}) => {
  useQuery(fetchAllCertsByEnvId({ id: envId }));
  const allCerts = useSelector((s) => selectCertificatesByEnvId(s, { envId }));

  // Filter out managed certificates
  const selectableCerts = allCerts.filter((cert) => !cert.acme);
  const selectLabel =
    selectableCerts.length > 0
      ? "Select an Existing Certificate"
      : "No custom certificates found";

  const options: SelectOption[] = [{ label: selectLabel, value: "" }];
  selectableCerts.forEach((cert) => {
    options.push({ label: getCertLabel(cert), value: cert.id });
  });

  return (
    <Select
      id="existing-cert"
      ariaLabel="existing-cert"
      options={options}
      onSelect={onSelect}
      value={selectedId}
      className={className}
      disabled={!selectableCerts.length}
    />
  );
};
